// @flow
import type {
  ProductRankingState,
  ProductRankingAction
} from 'stores/flow-type/product-ranking.type';

import {
  GET_PRODUCT_RANKING_REQUEST,
  GET_PRODUCT_RANKING_SUCCESS,
  GET_PRODUCT_RANKING_FAILURE,
  UPDATE_PRODUCT_RANKING_REQUEST,
  UPDATE_PRODUCT_RANKING_SUCCESS,
  UPDATE_PRODUCT_RANKING_FAILURE
} from 'stores/flow-type/product-ranking.type';

const initialState: ProductRankingState = {
  loading: false,
  saving: false,
  success: false,
  saveSuccess: false,
  error: undefined,
  productRanking: [],
  total: 0,
  totalRanked: 0
};

const productRankingReducers = (
  state: ProductRankingState = initialState,
  action: ProductRankingAction
) => {
  switch (action.type) {
    case GET_PRODUCT_RANKING_REQUEST:
      return { ...state, loading: true };

    case UPDATE_PRODUCT_RANKING_REQUEST:
      return { ...state, saving: true, saveSuccess: false };
    case GET_PRODUCT_RANKING_SUCCESS: {
      const { data = {} } = action.payload;
      const { data: productRanking, total, totalRanked } = data;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        productRanking,
        total,
        totalRanked
      };
    }
    case UPDATE_PRODUCT_RANKING_SUCCESS: {
      // Keep the current data
      const { products: productRanking = [], totalRanked } = action.payload;
      return {
        ...state,
        productRanking,
        saving: false,
        saveSuccess: true,
        error: undefined,
        totalRanked
      };
    }
    case GET_PRODUCT_RANKING_FAILURE: {
      return {
        ...state,
        loading: false,
        saving: false,
        success: false,
        error: action.payload
      };
    }
    case UPDATE_PRODUCT_RANKING_FAILURE: {
      return {
        ...state,
        loading: false,
        saving: false,
        saveSuccess: false,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
export default productRankingReducers;
